import { render } from "./searchorderuser.vue?vue&type=template&id=5c9cd5b0"
import script from "./searchorderuser.vue?vue&type=script&lang=js"
export * from "./searchorderuser.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__